import { StrictMode, Suspense } from 'react';
import * as ReactDOM from 'react-dom/client';
import './accessibility.css';
import './i18n/config';
import App from './app/App';
import { consumeHandoffJwt } from '@aegix/auth-core';
import { initializeSentry } from './bootstrap/sentrySetup';
import * as Sentry from '@sentry/react';

// Error fallback component for Sentry ErrorBoundary
function ErrorFallback() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>Something went wrong</h1>
      <p>We've been notified and are working to fix the issue.</p>
      <button type="button" onClick={() => window.location.reload()}>Reload page</button>
    </div>
  );
}

// Take the SSO handoff token out of the URL. This MUST stay above
// `initializeSentry()`: Session Replay starts synchronously inside
// `Sentry.init` and records `location.search`/`href` into the replay
// envelope before React renders, and the replay envelope never passes
// through `beforeSend`, so nothing scrubs it afterwards. Routes read the
// token via `getHandoffJwt()` / `takeHandoffJwt()`. Order is pinned by test.
consumeHandoffJwt({ pathPrefixes: ['/oauth-success'] });

// Initialize error tracking
initializeSentry()

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog>
    <StrictMode>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </StrictMode>
  </Sentry.ErrorBoundary>
);
